/* One place for the look and feel of the whole app (antd design tokens). */
export const BRAND_NAVY = '#053380';

const theme = {
    token: {
        colorPrimary: BRAND_NAVY,
        colorInfo: BRAND_NAVY,
        colorLink: BRAND_NAVY,
        colorBgLayout: '#f4f6fb',
        colorText: '#1f2937',
        colorTextHeading: '#1f2937',
        colorTextSecondary: '#4b5563',
        colorError: '#d9001b',
        borderRadius: 6,
        fontFamily: "'Merriweather Sans', sans-serif",
        fontSize: 14,
        controlHeight: 36,
    },
    components: {
        Layout: {
            siderBg: '#041b4d',
            triggerBg: '#03153a',
            headerBg: '#ffffff',
            footerBg: '#f4f6fb',
        },
        Menu: {
            darkItemBg: '#041b4d',
            darkSubMenuItemBg: '#031440',
            darkItemSelectedBg: '#1d4ed8',
            darkItemHoverBg: 'rgba(255, 255, 255, 0.08)',
        },
        Card: {
            headerFontSize: 16,
        },
        Table: {
            headerBg: '#eef2f8',
            headerColor: '#1f2937',
            rowHoverBg: '#f5f8ff',
            cellPaddingBlock: 10,
        },
        Button: {
            primaryShadow: 'none',
            defaultShadow: 'none',
        },
        Form: {
            labelColor: '#1f1f1f',
        },
    },
};

export default theme;
